import { useEffect, useRef } from "react";
import { PostcodeLookup } from "@ideal-postcodes/postcode-lookup";

function PostcodeLookupComponent({
    apiKey,
    onReady,
    onAddressesRetrieved,
    onSearchCompleted,
    onAddressSelected,
    onSearchError,
}) {
    const context = useRef(null);
    const callbacksRef = useRef({});

    callbacksRef.current = {
        onReady,
        onAddressesRetrieved,
        onSearchCompleted,
        onAddressSelected,
        onSearchError,
    };

    useEffect(() => {
        if (!context.current || !apiKey) return undefined;

        const controller = PostcodeLookup.setup({
            apiKey: apiKey,
            context: context.current,
            selectSinglePremise: true,
            autoSearchSingleSuggestion: true,
            hide: [],
            onAddressesRetrieved: (...args) =>
                callbacksRef.current.onAddressesRetrieved?.(...args),
            onSearchCompleted: (...args) =>
                callbacksRef.current.onSearchCompleted?.(...args),
            onAddressSelected: (...args) =>
                callbacksRef.current.onAddressSelected?.(...args),
            onSearchError: (...args) =>
                callbacksRef.current.onSearchError?.(...args),
        });
        callbacksRef.current.onReady?.(controller);
        return () => controller?.removeAll?.();
    }, [apiKey]);

    return <div ref={context} className="hidden" />;
}

export default PostcodeLookupComponent;
